import React from 'react';
import OthersPage from "./OthersPage"
import { graphql } from "gatsby"

export default function BannerTerminos({titulo, text, bgColor, imagen}) {

  return (
    <OthersPage
      bgColor={bgColor}
      titulo={titulo}
      text={text}
      imagen={imagen}
    />
  );

}

export const queryBannerTerminos = graphql`
  fragment bannerTerminos on Wordpress_Template_TerminosYCondiciones_Terminosycondiciones{
    colorFondo
    texto
    imagen {
      ...imagen
    }
  }
`